import React, {useState} from "react";
import {
    Box,
    Typography,
    FormControl,
    FormControlLabel,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  RadioGroup,
  Radio,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import image from "../assets/images/image.png";
const Metadata=({isDialogOpen,metaData,metadata,setIsDialogOpen})=>{
return(
    <Dialog open={isDialogOpen} maxWidth="xl" fullWidth>
                            <DialogTitle>
                              <Box
                                mt={2}
                                sx={{
                                  position: "relative",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {metadata && (
                                  <Typography sx={{ flexGrow: 1, textAlign: "center" }}>
                                    MetaData
                                  </Typography>
                                )}
                
                                <Box
                                  sx={{
                                    position: "absolute",
                                    right: 0,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <button
                                    onClick={() => setIsDialogOpen(false)}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "40px",
                                      height: "40px",
                                      cursor: "pointer",
                                      background: "none",
                                      borderRadius: "50%",
                                      border: "1px solid #ccc",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <IoClose size={16} />
                                  </button>
                                </Box>
                              </Box>
                            </DialogTitle>
                
                            <DialogContent>
                              <Box>
                                {metadata && (
                                  <div className="flex justify-center mt-6">
                                    <TableContainer
                                      component={Paper}
                                      sx={{ maxWidth: 800, margin: "auto", marginTop: 4 }}
                                    >
                                      <Table sx={{ border: "2px solid black" }}>
                                        <TableHead>
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell
                                              sx={{
                                                fontWeight: "bold",
                                                border: "2px solid black",
                                              }}
                                            >
                                              Field
                                            </TableCell>
                                            <TableCell
                                              sx={{
                                                fontWeight: "bold",
                                                border: "2px solid black",
                                              }}
                                            >
                                              Metadata
                                            </TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {metaData.all.map((replacement, index) => (
                                            <TableRow
                                              key={index}
                                              sx={{ borderBottom: "2px solid black" }}
                                            >
                                              <TableCell sx={{ border: "2px solid black" }}>
                                                {`<${replacement?.fieldname} >`|| "N/A"}
                                              </TableCell>
                                              <TableCell sx={{ border: "2px solid black" }}>
                                                {replacement?.description || "N/A"}
                                              </TableCell>
                                            </TableRow>
                                          ))}
                
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"<image>"}
                                            </TableCell>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"Photo"}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"<signature>"}
                                            </TableCell>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"Signature"}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"<barcode>"}
                                            </TableCell>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"Barcode"}
                                            </TableCell>
                                          </TableRow>
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell
                                              sx={{ border: "2px solid black", color: "red" }}
                                            >
                                              {"ONLY THESE FONT TO USED"}
                                            </TableCell>
                                            <TableCell
                                              sx={{ border: "2px solid black", color: "red" }}
                                            >
                                              <ul style={{ paddingLeft: "16px", margin: 0 }}>
                                                {[
                                                  "Arial",
                                                  "Arial Black",
                                                  "Bahnschrift",
                                                  "Bahnschrift Condensed",
                                                  "Bahnschrift Light",
                                                  "Bahnschrift Light Condensed",
                                                  "Bahnschrift Light SemiCondensed",
                                                  "Bahnschrift SemiBold",
                                                  "Bahnschrift SemiBold Condensed",
                                                  "Bahnschrift SemiBold SemiCondensed",
                                                  "Bahnschrift SemiCondensed",
                                                  "Bahnschrift SemiLight",
                                                  "Bahnschrift SemiLight Condensed",
                                                  "Bahnschrift SemiLight SemiCondensed",
                                                  "Calibri",
                                                  "Calibri Light",
                                                  "Cambria",
                                                  "Candara",
                                                  "Ebrima",
                                                  "Franklin Gothic Medium",
                                                  "Gabriola",
                                                  "Gadugi",
                                                  "Georgia",
                                                  "HoloLens MDL2 Assets",
                                                  "Impact",
                                                  "Ink Free",
                                                  "Javanese Text",
                                                  "Leelawadee UI",
                                                  "Leelawadee UI Semilight",
                                                  "Lucida Console",
                                                  "Lucida Sans Unicode",
                                                  "Malgun Gothic",
                                                  "Microsoft Himalaya",
                                                  "Microsoft JhengHei",
                                                  "Microsoft JhengHei Light",
                                                  "Microsoft JhengHei UI",
                                                  "Microsoft JhengHei UI Light",
                                                  "Microsoft New Tai Lue",
                                                  "Microsoft PhagsPa",
                                                  "Microsoft Sans Serif",
                                                  "Microsoft Tai Le",
                                                  "Microsoft YaHei",
                                                  "Microsoft YaHei Light",
                                                  "Microsoft YaHei UI",
                                                  "Microsoft YaHei UI Light",
                                                  "Microsoft Yi Baiti",
                                                  "MingLiU-ExtB",
                                                  "MingLiU_HKSCS-ExtB",
                                                  "Mongolian Baiti",
                                                  "MS Gothic",
                                                  "MS PGothic",
                                                  "MS UI Gothic",
                                                  "MV Boli",
                                                  "Myanmar Text",
                                                  "Nirmala UI",
                                                  "Nirmala UI Semilight",
                                                  "NSimSun",
                                                  "Palatino Linotype",
                                                  "PMingLiU-ExtB",
                                                  "Segoe MDL2 Assets",
                                                  "Segoe Print",
                                                  "Segoe Script",
                                                  "Segoe UI",
                                                  "Segoe UI Black",
                                                  "Segoe UI Emoji",
                                                  "Segoe UI Historic",
                                                  "Segoe UI Light",
                                                  "Segoe UI Semibold",
                                                  "Segoe UI Semilight",
                                                  "Segoe UI Symbol",
                                                  "SimSun",
                                                  "SimSun-ExtB",
                                                  "Sitka Banner",
                                                  "Sitka Display",
                                                  "Sitka Heading",
                                                  "Sitka Small",
                                                  "Sitka Subheading",
                                                  "Sitka Text",
                                                  "Sylfaen",
                                                  "Tahoma",
                                                  "Times New Roman",
                                                  "Trebuchet MS",
                                                  "Verdana",
                                                  "Yu Gothic",
                                                  "Yu Gothic Light",
                                                  "Yu Gothic Medium",
                                                  "Yu Gothic UI",
                                                  "Yu Gothic UI Light",
                                                  "Yu Gothic UI Semibold",
                                                  "Yu Gothic UI Semilight",
                                                ].map((font, index) => (
                                                  <li key={index} style={{ fontFamily: font }}>
                                                    {font}
                                                  </li>
                                                ))}
                                              </ul>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"For Image"}
                                            </TableCell>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {
                                                "Need to draw a Text box and inside that meta data to be updated"
                                              }
                                              <img src={image} />
                                            </TableCell>
                                          </TableRow>
                                          <TableRow sx={{ borderBottom: "2px solid black" }}>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {"For Barcode"}
                                            </TableCell>
                                            <TableCell sx={{ border: "2px solid black" }}>
                                              {
                                                "Need to draw a Text box and inside that meta data to be updated"
                                              }
                                              <img src={image} />
                                            </TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </div>
                                )}
                              </Box>
                            </DialogContent>
                          </Dialog>
)
}
export default Metadata;